import React from 'react';

import Button from '../../../shared/design-system/ui/button';

import { AuthHelper } from '../../../shared/utils';

const DemoAccountBanner = () => (
  <div className="demo-account-alert d-flex" data-banner>
    <span className="demo-account-text">Demo Account</span>
    <span className="demo-account-divider" />
    <span className="demo-account-description">
      Sign up to access all Saleshandy features
    </span>

    <Button
      className="switch-now-btn"
      onClick={() => {
        AuthHelper.logoutDemoAccount();
      }}
    >
      Sign Up
    </Button>
  </div>
);

export default DemoAccountBanner;
